export const CITIES = [
  {
    slug: "schertz-tx",
    city: "Schertz",
    region: "TX",
    headline: "General Contractor in Schertz, TX",
    nearby: ["Cibolo", "Universal City", "Selma", "Live Oak", "Garden Ridge"],
    intro:
      "B3 Contracting LLC is a family-owned general contractor based right here in Schertz, Texas. Owner Blake Anderson grew up in Schertz and has spent years helping local homeowners with everything from quick repairs to full remodels. When you hire B3, you're working with a neighbor who treats your home like his own.",
    blurb:
      "From kitchen and bathroom remodels to new fences, painting, HVAC, roofing and everyday repairs, B3 Contracting is your one call for dependable home improvement in Schertz.",
  },
  {
    slug: "new-braunfels-tx",
    city: "New Braunfels",
    region: "TX",
    headline: "General Contractor in New Braunfels, TX",
    nearby: ["Cibolo", "Seguin", "Schertz", "Garden Ridge", "San Antonio"],
    intro:
      "Homeowners across New Braunfels trust B3 Contracting LLC for remodeling, fencing, painting and general contracting done right the first time. We bring clear communication, dependable scheduling and quality workmanship to every project in the New Braunfels area.",
    blurb:
      "Planning a remodel, need a new fence, or tackling repairs in New Braunfels? B3 Contracting handles projects big and small with honest pricing and craftsmanship you can count on.",
  },
  {
    slug: "cibolo-tx",
    city: "Cibolo",
    region: "TX",
    headline: "General Contractor in Cibolo, TX",
    nearby: ["Schertz", "New Braunfels", "Universal City", "Selma", "Garden Ridge"],
    intro:
      "B3 Contracting LLC proudly serves Cibolo, TX with a full range of home improvement services. As a local, family-owned contractor just minutes away in Schertz, we make it easy for Cibolo homeowners to get quality work without the runaround.",
    blurb:
      "Remodeling, home additions, concrete and outdoor projects, flooring, drywall and more — B3 Contracting is Cibolo's dependable choice for property improvements.",
  },
];

export const getCity = (slug) => CITIES.find((c) => c.slug === slug);
